import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function DailyWins() {
  const data = promotionsData.find((promo) => promo.title === "Daily Wins")
  const { setShowEasterEgg } = useGlobalContext()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Daily Wins</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Daily Tournament & Weekly Wheel Drops</h1>
                <h2>
                  Daily Wins will run from 24th March 2025 to 30th March 2026
                  with total of ₱200,000,000 to be awarded across 12 levels.
                </h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>March 24, 2025 - March 30, 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Level 9: Weekly Wheel Drops</strong>

                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>7</td>
                        <td>x1000 Multiplier</td>
                      </tr>
                      <tr>
                        <td>20</td>
                        <td>x100 Multiplier</td>
                      </tr>
                      <tr>
                        <td>73</td>
                        <td>x50 Multiplier</td>
                      </tr>
                      <tr>
                        <td>200</td>
                        <td>x20 Multiplier</td>
                      </tr>
                      <tr>
                        <td>700</td>
                        <td>x10 Multiplier</td>
                      </tr>
                      <tr>
                        <td>5,000</td>
                        <td>x8 Multiplier</td>
                      </tr>
                      <tr>
                        <td>20,000</td>
                        <td>x5 Multiplier</td>
                      </tr>
                      <tr>
                        <td>1,000</td>
                        <td>Instant Bonus</td>
                      </tr>
                      <tr>
                        <td>20,000</td>
                        <td>20 Free Spins</td>
                      </tr>
                      <tr>
                        <td>53,000</td>
                        <td>10 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <strong>
                  Level 9: Daily Slot Tournaments – Largest Win From A Single
                  Spin
                </strong>

                <div className="table-wrapper">
                  <table className="promotion-tnc-table daily-wins-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>Prize Pool</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>x1000</td>
                      </tr>
                      <tr>
                        <td>2 - 5</td>
                        <td>x200</td>
                      </tr>
                      <tr>
                        <td>6 - 20</td>
                        <td>x80</td>
                      </tr>
                      <tr>
                        <td>21 - 200</td>
                        <td>x10</td>
                      </tr>
                      <tr>
                        <td>201 - 1000</td>
                        <td>x5</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    className="promotion-cta-btn"
                    href="https://pp88.asia/tl/promotion/daily-wins/"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
